<template>
  <v-container fluid>
    <div v-if="loading">
      <div class="mb-3">
        <v-skeleton-loader type="list-item-two-line"></v-skeleton-loader>
      </div>
      <v-skeleton-loader type="table"></v-skeleton-loader>
    </div>
    <div v-else>
      <div class="text-h1 mb-4">
        <v-row>
          <v-col cols="12">
            <div class="text-h2 text-primary mb-0">
              Relatórios / Unidades Consumidoras
            </div>
          </v-col>
          <v-col cols="11" class="pt-0">
            <v-row no-gutters>
              <v-col cols="2">
                <v-autocomplete
                  :menu-props="{ offsetY: true}"
                  :items="concessionarias"
                  label="Concessionária"
                  append-icon="expand_more"
                  v-model="concessionaria"
                  hide-details=""
                  :loading="loading || loadingConcessionarias"
                  :disabled="loading || loadingConcessionarias"
                  outlined
                  clearable
                  clear-icon="close"
                  @change="getUnidades()"
                ></v-autocomplete>
              </v-col>
              <v-col cols="4">
                <v-autocomplete
                  class="ml-3"
                  :menu-props="{ offsetY: true}"
                  :items="unidades"
                  label="Unidade consumidora"
                  append-icon="expand_more"
                  v-model="unidade"
                  hide-details=""
                  :loading="loading || loadingUnidades"
                  :disabled="loading || loadingUnidades"
                  outlined
                  clearable
                  clear-icon="close"
                ></v-autocomplete>
              </v-col>
              <v-col cols="1">
                <div class="ml-3 search_btn">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn color="ui-btn-inherit ui-search_btn" v-bind="attrs" v-on="on" :loading="loadingSearch" :disabled="loadingSearch" @click="applyFilter()">
                        <v-icon>search</v-icon>
                      </v-btn>
                    </template>
                    <span>Filtrar</span>
                  </v-tooltip>
                </div>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="1" class="pt-0 text-center">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn class="ui-btn-inherit mt-1" v-bind="attrs" v-on="on" @click="print()">
                  <v-icon large color="primary">
                    print
                  </v-icon>
                </v-btn>
              </template>
              <span>Imprimir relatório</span>
            </v-tooltip>
          </v-col>
        </v-row>
      </div>
      <div id="print" v-if="dados && dados.length > 0">
        <div class="impressao__header text-center">
          <img v-if="!user.logo_sistema" class="impressao__logo" src="@assets/img/logo.png" alt="SolarMaker">
          <img v-else class="impressao__logo" :src="user.logo_sistema" alt="Logo sistema">
          <p>Relatório de Unidades Consumidoras</p>
        </div>
        <div v-for="(itemPai, indexPai) in dados" :key="indexPai" class="mb-3" v-show="itemPai.unidades.length > 0">
          <div class="text-h3 text-primary mb-2">
            {{itemPai.con_nome}}
          </div>
          <div v-for="(unidade, index) in itemPai.unidades" :key="index" class="mb-4">
            <div class="text-h3 text-primary mb-2 unidade_cliente">
              {{unidade.cliente ? `${unidade.cliente.cli_nome} - ${unidade.cliente.cli_cidade}/${unidade.cliente.cli_uf}` : 'Cliente excluído'}}
            </div>
            <v-simple-table class="base_table">
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left" width="20%">
                      Código
                    </th>
                    <th class="text-center" width="20%">
                      Nome
                    </th>
                    <th class="text-center" width="20%">
                      Classificação
                    </th>
                    <th class="text-center" width="20%">
                      Tipo comercial
                    </th>
                    <th class="text-center" width="20%">
                      Modalidade tarifária
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td class="text-left">
                      {{unidade.uco_codigo}}
                    </td>
                    <td class="text-center">{{unidade.uco_nome}}</td>
                    <td class="text-center">{{unidade.uco_classificacao}}</td>
                    <td class="text-center">{{tipos[unidade.uco_tipo - 1].text}}</td>
                    <td class="text-center">{{unidade.uco_modalidade}}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
            <div v-if="unidade.faturas && unidade.faturas.length">
              <p class="mb-1 mt-2 pl-1 unidade_faturas">Faturas</p>
              <v-simple-table class="base_table">
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left">
                        Início do Ciclo
                      </th>
                      <th class="text-center">
                        Fim do Ciclo
                      </th>
                      <th class="text-center">
                        Valor Faturado
                      </th>
                      <th class="text-center">
                        Valor da Tarifa
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr  v-for="(fatura, indexFatura) in unidade.faturas" :key="indexFatura">
                      <td class="text-left">{{$root.Formatter.formatDate(fatura.ucf_inicio_ciclo, 'L')}}</td>
                      <td class="text-center">{{$root.Formatter.formatDate(fatura.ucf_fim_ciclo, 'L')}}</td>
                      <td class="text-center">{{$root.Formatter.floatToMoney(fatura.ucf_valor_faturado)}}</td>
                      <td class="text-center">{{$root.Formatter.floatToMoney(fatura.ucf_valor_tarifa)}}</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </div>
          </div>
        </div>
        <div v-if="!!concessionaria && dados[0].unidades.length == 0">
          Nenhum dado encontrado.
        </div>
      </div>
      <div v-else>
        Nenhum dado encontrado.
      </div>
    </div>
  </v-container>
</template>

<script>
import Api from '@API'
import Printd from 'printd'
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css'
export default {
  components: {
    VueCtkDateTimePicker
  },
  data () {
    return {
      user: null,
      loading: true,
      concessionaria: null,
      concessionarias: [],
      loadingConcessionarias: false,
      unidade: null,
      unidades: [],
      loadingUnidades: false,
      dados: [],
      tipos: [
        {
          text: 'Comercial',
          value: 1
        },
        {
          text: 'Rural Agroindustrial',
          value: 2
        },
        {
          text: 'Residencial',
          value: 3
        },
        {
          text: 'Comercial Outros Serviços e Outras Atividades',
          value: 4
        },
        {
          text: 'Comercial Serviços de Comunicações e Telecomunicações',
          value: 5
        },
        {
          text: 'Industrial Industrial',
          value: 6
        },
        {
          text: 'Rural Agropecuária Rural',
          value: 7
        },
        {
          text: 'Poder Público Federal',
          value: 8
        }
      ]
    }
  },
  methods: {
    async print () {
      const d = new Printd()
      let styles = [
        `
          body {
            overflow: hidden;
            font-family: "Arial", sans-serif !important;
          }
          p, strong, b, small, span, q, i, td {
            color: #000!important;
            font-size: .85rem!important;
            line-height: .9rem!important;
            word-break: keep-all!important;
          }
          .v-application {
            font-family: "Arial", sans-serif !important;
          }
        `,
        `
          .impressao__header {
            width: 100%;
            text-align: center;
            color: #000!important;
          }
          .impressao__header p {
            margin-top: 1em;
            font-size: 14px;
            font-weight: bold;
          }
          .impressao__logo {
            max-width: 20%;
            color: #000!important;
          }
          .impressao__footer {
            bottom: 0;
            position: fixed;
            width: 100%;
            display: none;
          }
          .impressao__footer_text {
            text-align: center;
            color: #d0d0d0;
            font-size: 11px;
            padding-top: 5px;
          }
          .impressao__footer_hr {
            margin-bottom: 10px;
          }
          .impressao__break {
            page-break-after: always;
          }
          .impressao__footer, .impressao__footer-space {
            height: 2em;
          }
          .unidade_cliente {
            font-size: 14px!important;
          }
          .unidade_faturas {
            margin-top: 1em;
            font-size: 13px!important;
          }
          #print .text-h3 {
            font-weight: bold;
            font-size: 13px;
            margin-top: 3em;
          }
          @media screen {
            .impressao__footer {
              display: none;
            }
          }
          @media print {
            thead {display: table-header-group;}
            tfoot {display: table-footer-group;}
            button {display: none;}
            body {margin: 0;}
            * {
              color: #000!important;
            }
            .v-data-table th {
              border-bottom: thin solid rgba(0,0,0,.12)!important;
              min-width: 4em;
            }
            .v-data-table td {
              border-bottom: thin solid rgba(0,0,0,.12)!important;
              max-width: 20em;
            }
            .v-data-table .text-center {
              text-align: center;
            }
            p {
              widows: 3;
            }

            .impressao__footer {
              display: block;
            }
            .impressao__header {
              display: block;
              width: 100%;
              color: #000!important;
            }
          }
          @page {
            size: A4 !important;
            margin: 12mm;
          }
        `,
        'https://fonts.googleapis.com/css?family=Roboto:100,300,400,500,700,900',
        'https://cdn.jsdelivr.net/npm/vuetify@2.x/dist/vuetify.min.css'
      ]

      let documento = document.getElementById('print')
      await d.print(documento, styles)
    },
    applyFilter () {
      this.loading = true
      this.loadingSearch = true
      let query = Object.assign({},
        this.concessionaria ? { concessionaria: this.concessionaria } : '',
        this.unidade ? { unidade: this.unidade } : ''
      )
      this.$router.replace({name: 'RelatoriosUnidades', query: query}).catch(() => {})

      this.getDados()
    },
    loadContent () {
      let filters = this.$route.query
      if (filters.concessionaria) this.concessionaria = filters.concessionaria
      if (filters.unidade) this.unidade = filters.unidade
      this.getConcessionarias()
      this.getUnidades()
      this.getDados()
    },
    async getConcessionarias () {
      this.loadingConcessionarias = true
      await Api.get('concessionarias')
        .then(res => {
          var arrayInt = []
          res.data.map(int => {
            arrayInt.push({
              'text': int.con_nome,
              'value': int.uuid_con_id
            })
          })
          this.concessionarias = arrayInt
          this.loadingConcessionarias = false
        })
        .catch(err => {
          this.loadingConcessionarias = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar as concessionárias!',
            color: 'error'
          })
          console.log(err)
        })
    },
    async getUnidades () {
      this.loadingUnidades = true
      let endpoint = 'unidades-consumidoras'

      if (this.concessionaria) {
        this.unidade = null
        endpoint += `?concessionaria=${this.concessionaria}`
      }
      await Api.get(endpoint)
        .then(res => {
          var arrayInt = []
          res.data.map(int => {
            let text = int.uco_nome
            if (int.cliente) {
              text += ` - ${int.cliente.cli_nome}`
            }
            arrayInt.push({
              'text': text,
              'value': int.uuid_uco_id
            })
          })
          this.unidades = arrayInt
          this.loadingUnidades = false
        })
        .catch(err => {
          this.loadingUnidades = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar as concessionárias!',
            color: 'error'
          })
          console.log(err)
        })
    },
    async getDados () {
      this.loading = true
      let endpoint = '?filtro='
      if (this.concessionaria) {
        endpoint += `&concessionaria=${this.concessionaria}`
      }
      if (this.unidade) {
        endpoint += `&unidade=${this.unidade}`
      }

      await Api.get('relatorios/unidades' + endpoint)
        .then(res => {
          this.dados = res.data
          this.loading = false
          this.loadingSearch = false
        })
        .catch(err => {
          this.loading = false
          this.loadingSearch = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar os relatórios de concessionárias!',
            color: 'error'
          })
          console.log(err)
        })
    }
  },
  created () {
    this.user = JSON.parse(localStorage.getItem('user'))
    this.loadContent()
  }
}
</script>

<style lang="scss" scoped>
@import "@scss/_variables.scss";
@import "@scss/_ui.scss";
.item_lista {
  border: 1px $primary solid;
  border-left-width: 10px;
  height: 100%;
  padding: 15px;
  .text-h3 {
    margin-bottom: 25px;
    position: relative;
    &:before {
      background: $primary;
      bottom: -10px;
      content: '';
      height: 1px;
      left: -15px;
      position: absolute;
      width: calc(100% + 30px);
    }
  }
  @media (max-width: 767px){}
}
.impressao__header {
  width: 100%;
  display: none;
}
.unidade_cliente {
  font-size: 16px!important;
}
</style>



// WEBPACK FOOTER //
// src/pages/relatorios/operacional/Unidades.vue